<section *ngIf="menu$ | async as menu">
    <div>
        <div (click)="toggleNavState()" class="collapse">
            <mat-icon
                [matTooltip]="!isCollapsed ? 'Collapse' : 'Expand'"
                matTooltipPosition="right"
                [class]="!isCollapsed ? 'collapse-icon' : 'collapse-icon expanded'"
                >keyboard_arrow_left</mat-icon
            >
        </div>
        <ng-container *ngFor="let menuItem of menu">
            <nav-item [isCollapsed]="!isCollapsed" [item]="menuItem" (outEvent)="eventHandler($event)"> </nav-item>
        </ng-container>
    </div>

    <button
        *ngIf="!isCollapsed"
        mat-button
        [class]="getButtonClass()"
        (click)="download()"
        matTooltip="The DDJ print driver is available as part of an enhanced service package. Contact us at {{ supportPhone }} to learn more."
    >
        <mat-icon>download_for_offline</mat-icon>
        <span *ngIf="!isCollapsed"> Download Print-to-DDJ </span>
    </button>
</section>
